import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import { LenisScroller } from './components/LenisScroller';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Story } from './components/Story';
import { Benefits } from './components/Benefits';
import { Marquee } from './components/Marquee';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import Admin from './components/Admin';
import { trackEvent } from './api';

const Home = () => {
  useEffect(() => {
    trackEvent('page_view', 'home');
  }, []);

  return (
    <LenisScroller>
      <div className="min-h-screen">
        <Header />
        <Hero />
        <Stats />
        <div id="services">
          <Services />
        </div>
        <div id="about">
          <Story />
        </div>
        <Benefits />
        <Marquee />
        <div id="reviews">
          <Testimonials />
        </div>
        <Contact />
        <Footer />
      </div>
    </LenisScroller>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors />
    </div>
  );
}

export default App;
